import { useState } from "react";
import { validUser } from "../helpers/tableauUserHelpers";
import { useNavigate } from "react-router-dom";
import { ccbhmessagebox, removeMsg } from "../scripts/ccbh.ui";
import PageLogoHeader from "./pageLogoHeader";

import "./passwordrecovery.css";

function PasswordRecovery(){
    let navigate = useNavigate();

    const [webuserID, setWebuserID] = useState('');
    const [disableRequest, setDisableRequest] = useState('disabled');

    const fetchValidUser = async(username) =>{
        return await validUser(username);
    }

    const handleUsernameChange = event => {
        setWebuserID(event.target.value);
        if(webuserID !== ''){
            setDisableRequest('');
        }else{
            setDisableRequest('disabled');
        }   
    }

    const attemptPasswordRecover = async() =>{
        const msg = await fetchValidUser(webuserID);
        if(msg !== '' && msg !== undefined && msg !== null){
            ccbhmessagebox({
                message: msg,
                title: "Password Reset",
                modal:true,
                closebutton: false,
                buttons: {
                    'Ok': function() {
                        removeMsg();
                        navigate("/");
                    }
                }
            });
        }
    }

    return(
        <>
        <PageLogoHeader />

        <p className="message" id="password-request">
            You are requesting to reset your password.  
            <br/><br/>
            If this is correct, when you press the <b>REQUEST NEW PASSWORD</b> button,
            an email will be sent to the email address that is on file.  
            <br/><br/>
            If you do not wish to do this press CANCEL
        </p>
        <br /><br />

        <div id="password-request-username">
            <input type="text" id="username" name="username" defaultValue="" onChange={handleUsernameChange} onBlur={handleUsernameChange}/>
            <label htmlFor="username" id="password_label">Username</label>
        </div>
        <br />
        <div className="button_section">
            <a href="/" className="fake_button" id="password-reset-cancel">Cancel</a>
            <input type="submit" className="fake" disabled={disableRequest} id="password-reset-request" name="password-reset-request" value="Request New Password" onClick={attemptPasswordRecover}/>
        </div>
    </>

    );
}
export default PasswordRecovery;